import { AggregatePeriod } from 'v2/core/entities';

export const getAggregatePeriodLabel = (aggregatePeriod: AggregatePeriod) => {
  switch (aggregatePeriod) {
    case AggregatePeriod.DAY:
      return 'day';
    case AggregatePeriod.WEEK:
      return 'week';
    case AggregatePeriod.MONTH:
      return 'month';
    default:
      return 'day';
  }
};
